import { DatagridCell, DatagridRow } from 'Storybook/core/Datagrid';
import Skeleton from 'Storybook/core/Skeleton/Skeleton';
import type { SkeletonSize } from 'Storybook/core/Skeleton/Skeleton.types';
import SkeletonVehicleData from 'Storybook/peripheral/VehicleData/SkeletonVehicleData/SkeletonVehicleData';

import styles from './ProcessingBidsView.module.scss';

const SKELETON_ROWS = Array.from({ length: 5 });

interface SkeletonCellProps {
	index: number;
	rowIndex: number;
	width: SkeletonSize;
}

const SkeletonCell: React.FC<SkeletonCellProps> = ({ index, rowIndex, width }) => (
	<div className={styles.skeletonCellContainer}>
		<DatagridCell index={index} rowIndex={rowIndex}>
			<div className={styles.datagridCellTextContainer}>
				<Skeleton className={styles.skeleton} isAnimated={false} width={width} />
			</div>
		</DatagridCell>
	</div>
);

export const ProcessingDatagridSkeleton: React.FC = () => {
	return (
		<>
			{SKELETON_ROWS.map((_, index) => (
				<DatagridRow
					key={index}
					gridClass={styles.skeletonDatagridCustom}
					id={index.toString()}
					index={index}
					isInteractive={false}
				>
					<DatagridCell index={0} rowIndex={index}>
						<SkeletonVehicleData className={styles.skeleton} isAnimated={false} />
					</DatagridCell>
					<SkeletonCell index={1} rowIndex={index} width={15} />
					<SkeletonCell index={2} rowIndex={index} width={10} />
				</DatagridRow>
			))}
		</>
	);
};
